import React, { useEffect, useState } from 'react'
import { Box, Input, MenuItem, Select, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { selectMatchInputSx } from '../Dropdown'
import useStyles from './styles'
import useGlobalStyles from '../../utils/globalStyles'

const OTHER = '__other__'

// Store Type: one of the Shop Types (decides the home screen tile the store is
// listed under) or a custom label typed under "Other". The saved value is the
// shop type's title, which is also what the store card shows.
export const findShopType = (shopTypes, value) => {
  const key = (value || '').trim().toLowerCase()
  if (!key) return undefined
  return shopTypes.find(
    type =>
      type.slug?.toLowerCase() === key || type.title?.toLowerCase() === key
  )
}

function StoreTypeField({ shopTypes = [], value = '', onChange }) {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const matched = findShopType(shopTypes, value)
  const [other, setOther] = useState(false)

  // A saved custom label opens in "Other" mode
  useEffect(() => {
    if (value && shopTypes.length && !findShopType(shopTypes, value)) {
      setOther(true)
    }
  }, [value, shopTypes])

  const selected = other ? OTHER : matched ? matched.slug : ''

  return (
    <Box>
      <Typography className={classes.labelText}>
        {t('StoreTypeLabel')}
      </Typography>
      <Select
        sx={selectMatchInputSx}
        id="store-type"
        value={selected}
        displayEmpty
        onChange={event => {
          const next = event.target.value
          if (next === OTHER) {
            setOther(true)
            onChange('')
          } else {
            setOther(false)
            onChange(findShopType(shopTypes, next)?.title || '')
          }
        }}
        className={globalClasses.input}>
        <MenuItem value="">
          <Typography component="span" sx={{ color: 'text.disabled' }}>
            {t('SelectStoreType')}
          </Typography>
        </MenuItem>
        {shopTypes.map(type => (
          <MenuItem value={type.slug} key={type.slug}>
            {type.title}
          </MenuItem>
        ))}
        <MenuItem value={OTHER}>{t('OtherStoreType')}</MenuItem>
      </Select>
      {other && (
        <Input
          style={{ marginTop: 8 }}
          id="store-type-custom"
          placeholder={t('PHStoreType')}
          type="text"
          value={value}
          onChange={event => onChange(event.target.value)}
          disableUnderline
          className={globalClasses.input}
        />
      )}
      <Typography
        className={classes.labelText}
        style={{ opacity: 0.7, fontSize: 13 }}>
        {t('StoreTypeHelp')}
      </Typography>
    </Box>
  )
}

export default StoreTypeField
